import { Layer, Source } from "react-map-gl/mapbox"

interface ArgileLayerProps {
  opacity?: number
}

export const ArgileLayer = ({ opacity = 0.7 }: ArgileLayerProps) => {
  return (
    <Source
      id="raster-argile"
      type="raster"
      tiles={[
        "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=ALEARG_2025&STYLES=&CRS=EPSG%3A3857&TILED=true&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
      ]}
      tileSize={256}
      maxzoom={15}
    >
      <Layer id="raster-argile" type="raster" source="raster-argile" paint={{ "raster-opacity": opacity }} />
    </Source>
  )
}
